import {Pipe, PipeTransform} from '@angular/core';
import {ITimetable} from '../../models/timetable';

@Pipe({
  name: 'getTimetableByDay'
})
export class GetTimtableByDayPipe implements PipeTransform {

  transform(value: ITimetable[], day: number): ITimetable {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < value.length; i++) {
      if (value[i].day === day) {
        return value[i];
      }
    }
  }
}
